// Ekran „Sprawdź odpowiedzi" (wzorzec GOV.UK check-answers).
//
// Treść budujemy z żywego DOM-u formularza, nie z osobnej definicji: pola
// wyłączone (ROZSZ poza trybem pełnym, gałęzie warunkowe) mają disabled,
// więc same wypadają z podsumowania i klient widzi dokładnie to, co jego
// dotyczy. „Zmień" wraca potem na podsumowanie, a nie przepycha przez resztę.

const SKIP_NAMES = new Set(["source", "wersja", "ticket"]);

function cleanLabel(text) {
    return (text || "")
        .replace(/\*/g, "")
        .replace(/\(opcjonalne\)/gi, "")
        .replace(/\s+/g, " ")
        .trim();
}

function labelOf(wrapper) {
    const legend = wrapper.querySelector(":scope > legend");
    if (legend) return cleanLabel(legend.textContent);
    const label = wrapper.querySelector(":scope > .brief__label");
    if (label) return cleanLabel(label.textContent);
    return "";
}

// Wartość pola w formie czytelnej dla człowieka (etykiety opcji, nie slugi).
function valueOf(wrapper, uploads) {
    if (wrapper.classList.contains("brief__upload")) {
        const input = wrapper.querySelector(".brief__uploadInput");
        const files = uploads && input ? (uploads.collect()[input.name] || []) : [];
        if (!files.length) return "";
        return files.length === 1
            ? files[0].name
            : files.length + " " + (files.length < 5 ? "pliki" : "plików");
    }

    const checked = Array.from(wrapper.querySelectorAll("input:checked:not(:disabled)"));
    if (checked.length) {
        return checked
            .map((input) => {
                const tile = input.closest(".brief__tile, .brief__palette");
                const title = tile
                    ? tile.querySelector(".brief__tileTitle, .brief__paletteName")
                    : null;
                return title ? title.textContent.trim() : input.value;
            })
            .join(", ");
    }
    if (wrapper.querySelector('input[type="radio"], input[type="checkbox"]')) return "";

    const field = wrapper.querySelector("input:not([type=hidden]):not(:disabled), textarea:not(:disabled)");
    if (field && !SKIP_NAMES.has(field.name)) return (field.value || "").trim();

    const hidden = wrapper.querySelector('input[type="hidden"]:not(:disabled)');
    if (hidden) return (hidden.value || "").trim();

    return "";
}

function row(label, value, stepNr, onEdit) {
    const wrap = document.createElement("div");
    wrap.className = "brief__reviewRow";

    const dt = document.createElement("dt");
    dt.className = "brief__reviewKey";
    dt.textContent = label;

    const dd = document.createElement("dd");
    dd.className = "brief__reviewValue";
    if (value === "") {
        dd.textContent = "nie podano";
        dd.dataset.empty = "1";
    } else {
        dd.textContent = value;
    }

    const action = document.createElement("dd");
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "brief__linkBtn";
    btn.innerHTML =
        (value === "" ? "Uzupełnij" : "Zmień") +
        '<span class="visually-hidden"> — ' +
        label.toLowerCase() +
        "</span>";
    btn.addEventListener("click", () => onEdit(stepNr));
    action.appendChild(btn);

    wrap.append(dt, dd, action);
    return wrap;
}

export function initReview(form, api) {
    const review = form.querySelector("[data-review]");
    if (!review) return null;

    const body = review.querySelector("[data-review-body]");
    const gaps = review.querySelector("[data-review-gaps]");
    const gapsList = review.querySelector("[data-review-gaps-list]");

    function build() {
        if (!body) return;
        body.innerHTML = "";
        const missing = [];

        form.querySelectorAll(".brief__step").forEach((step) => {
            const nr = Number(step.dataset.step);
            const title = step.querySelector(".brief__stepTitle");
            const rows = [];

            step.querySelectorAll(".brief__field, .brief__group").forEach((wrapper) => {
                // pole w wyłączonej gałęzi warunkowej / poza trybem pełnym
                if (wrapper.closest("[hidden]") && wrapper.closest("[hidden]") !== step) return;
                if (wrapper.matches(".brief__field--hp, .brief__consent")) return;
                // zagnieżdżone .brief__field wewnątrz fieldsetu liczymy raz
                if (wrapper.parentElement.closest(".brief__group")) return;

                const label = labelOf(wrapper);
                if (!label) return;

                const active = wrapper.querySelector(
                    "input:not(:disabled), textarea:not(:disabled), select:not(:disabled)"
                );
                if (!active) return;

                const value = valueOf(wrapper, api.uploads);
                rows.push(row(label, value, nr, api.steps.editFromReview));

                if (value === "" && wrapper.hasAttribute("data-expected")) {
                    missing.push({ label, nr });
                }
            });

            if (!rows.length) return;

            const section = document.createElement("div");
            section.className = "brief__reviewSection";

            const heading = document.createElement("p");
            heading.className = "brief__reviewSectionTitle";
            heading.textContent = "Krok " + nr + " · " + (title ? title.textContent.trim() : "");

            const dl = document.createElement("dl");
            dl.className = "brief__reviewRows";
            rows.forEach((r) => dl.appendChild(r));

            section.append(heading, dl);
            body.appendChild(section);
        });

        if (gaps && gapsList) {
            gapsList.innerHTML = "";
            missing.forEach(({ label, nr }) => {
                const li = document.createElement("li");
                const btn = document.createElement("button");
                btn.type = "button";
                btn.className = "brief__linkBtn";
                btn.textContent = label;
                btn.addEventListener("click", () => api.steps.editFromReview(nr));
                li.appendChild(btn);
                gapsList.appendChild(li);
            });
            gaps.hidden = missing.length === 0;
        }
    }

    return { build };
}
